import { ReplaySubject } from 'rxjs';

export const launchDarklyUserSubject = new ReplaySubject(1);
export const appSyncClientSubject = new ReplaySubject(1);
export const unreadMessagesSubject = new ReplaySubject(1);
export const onNotificationCreateSubject = new ReplaySubject(1);
